import { getBrandLogo } from '@/src/constants/buildVariant'
import { CLEARTRIP } from '@/src/constants'
import { Brand } from '@/src/utils/brand'

export function getNavbarProperties(brand: Brand) {
    return {
        showMenuButton: brand === CLEARTRIP,
        brandLogo: getBrandLogo(brand)
    }
}
